import { httpClient } from "ultis/axios";

/**api lấy danh sách chiến dịch*/
const getListCampaign = (params) => {
  return httpClient.get("/mini-crm/campaign", {
    params,
  });
};

export const CampaignApi = {
  getListCampaign,
};
